import { render, staticRenderFns } from "./gen-poster.vue?vue&type=template&id=d121310c&scoped=true"
import script from "./gen-poster.vue?vue&type=script&lang=js"
export * from "./gen-poster.vue?vue&type=script&lang=js"
import style0 from "./gen-poster.vue?vue&type=style&index=0&id=d121310c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d121310c",
  null
  
)

export default component.exports